import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';

import CustomCol from '../../../components/CustomCol';
import CustomInputInt from '../../../components/CustomInputs/CustomInputInt';
import CustomInputMask from '../../../components/CustomInputs/CustomInputMask';
import CustomInputText from '../../../components/CustomInputs/CustomInputText';
import CustomRow from '../../../components/CustomRow';
import CustomSelect from '../../../components/CustomSelects/CustomSelect';
import { getInterfaces } from '../../../services/usuario/usuarioVinculoService';
import {
  getDominioOptions,
  transformarEnumOptionValueEmLabel,
} from '../../../utils/functions';

interface FormSolicitacaoProps {
  formData: {
    nome?: string;
    nuInterface: string | number;
    papelId: string | number;
    numeroSeiContrato: string;
    numeroDocumentoSEI: string;
    interfaceVinculo: string | number;
    interfaceId: string | number;
    observacao: string;
    [key: string]: any;
  };
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  disabled?: boolean;
}

const FormSolicitacao: React.FC<FormSolicitacaoProps> = ({
  formData,
  setFormData,
  disabled = false,
}) => {
  const [optionsInterface, setOptionsInterface] = useState<any[]>([]);
  const [optionsPapelUsuario, setOptionsPapelUsuario] = useState<any[]>([]);
  const [optionsInterfaceVinculo, setOptionsInterfaceVinculo] = useState<any[]>(
    [],
  );

  const interfaceLabel = transformarEnumOptionValueEmLabel(
    Number(formData.nuInterface),
    optionsInterface,
  );

  useEffect(() => {
    const fetchOptions = () => {
      const selInterface = getDominioOptions(97);
      setOptionsInterface(selInterface);

      const selPapelUsuario = getDominioOptions(101);
      setOptionsPapelUsuario(selPapelUsuario);
    };
    fetchOptions();
  }, []);

  // Carrega opções de vínculo quando a interface muda
  useEffect(() => {
    const loadInterfaceVinculo = async () => {
      if (formData.nuInterface && optionsInterface.length > 0) {
        const label = transformarEnumOptionValueEmLabel(
          Number(formData.nuInterface),
          optionsInterface,
        );

        try {
          const response = (await getInterfaces(label)) as any;
          if (response && response.registros) {
            setOptionsInterfaceVinculo([
              { value: 0, label: 'Não informado' },
              ...response.registros,
            ]);
          } else {
            setOptionsInterfaceVinculo([]);
          }
        } catch (error) {
          console.error('Erro ao carregar interfaces de vínculo', error);
          setOptionsInterfaceVinculo([]);
        }
      } else {
        setOptionsInterfaceVinculo([]);
      }
    };
    loadInterfaceVinculo();
  }, [formData.nuInterface, optionsInterface]);

  const handleChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = event.target;

    if (name === 'nuInterface') {
      // Ao mudar a interface, limpa os campos dependentes
      setFormData((prev: any) => ({
        ...prev,
        [name]: value,
        interfaceVinculo: '',
        interfaceId: '',
        numeroSeiContrato: '',
        numeroDocumentoSEI: '',
      }));
    } else if (name === 'interfaceVinculo') {
      setFormData((prev: any) => ({
        ...prev,
        interfaceVinculo: value,
        interfaceId: value,
      }));
    } else {
      setFormData((prev: any) => ({ ...prev, [name]: value }));
    }
  };

  return (
    <>
      <CustomRow>
        <CustomCol>
          <CustomInputText
            name="nome"
            value={formData.nome || ''}
            title="Nome"
            readOnly
          />
        </CustomCol>
      </CustomRow>
      <CustomRow>
        <CustomCol width="200px">
          <CustomSelect
            name="nuInterface"
            value={formData.nuInterface}
            options={optionsInterface}
            title="Interface"
            onChange={handleChange}
            required
            disabled={disabled}
          />
        </CustomCol>
        <CustomCol width="200px">
          <CustomSelect
            name="papelId"
            value={formData.papelId}
            options={optionsPapelUsuario}
            title="Papel Usuário"
            onChange={handleChange}
            required
            disabled={disabled}
          />
        </CustomCol>

        <CustomCol>
          <CustomInputMask
            id="numeroSeiContrato"
            name="numeroSeiContrato"
            value={formData.numeroSeiContrato}
            title="Nº Processo SEI"
            mask="99999.999999/9999-99"
            onChange={handleChange}
            readOnly={
              (interfaceLabel !== 'Fornecedor' && interfaceLabel !== 'SES') ||
              disabled
            }
            required={
              interfaceLabel === 'Fornecedor' || interfaceLabel === 'SES'
            }
            placeholder={
              interfaceLabel === 'Fornecedor' || interfaceLabel === 'SES'
                ? ''
                : 'Não se aplica'
            }
            // disabled={disabled}
          />
        </CustomCol>
        <CustomCol>
          <CustomInputText
            id="numeroDocumentoSEI"
            name="numeroDocumentoSEI"
            value={formData.numeroDocumentoSEI}
            title="Documento SEI"
            onChange={handleChange}
            readOnly={
              (interfaceLabel !== 'Fornecedor' && interfaceLabel !== 'SES') ||
              disabled
            }
            required={
              interfaceLabel === 'Fornecedor' || interfaceLabel === 'SES'
            }
            placeholder={
              interfaceLabel === 'Fornecedor' || interfaceLabel === 'SES'
                ? ''
                : 'Não se aplica'
            }
          />
        </CustomCol>
      </CustomRow>

      <CustomRow className="mb-3">
        <CustomCol>
          <CustomSelect
            name="interfaceVinculo"
            value={formData.interfaceVinculo}
            options={optionsInterfaceVinculo}
            title={
              formData.nuInterface ? interfaceLabel : 'Setor DAF/SES/Fornecedor'
            }
            required
            onChange={handleChange}
            disabled={!formData.nuInterface || disabled}
          />
        </CustomCol>
        <CustomCol width="150px">
          <CustomInputInt
            name="interfaceId"
            value={formData.interfaceId}
            title={'ID ' + (formData.nuInterface ? interfaceLabel : '')}
            readOnly
          />
        </CustomCol>
      </CustomRow>

      <CustomRow className="mb-3">
        <CustomCol width="100%">
          <CustomInputText
            id="observacao"
            name="observacao"
            value={formData.observacao}
            title="Observações"
            type="textArea"
            onChange={handleChange}
            rows={4}
          />
        </CustomCol>
      </CustomRow>
    </>
  );
};

export default FormSolicitacao;
